import type { FaireProductEntity } from "../../entity_types/product";

export const p_nc4f5tgnhy: FaireProductEntity = {
  token: "p_nc4f5tgnhy",
  type: "product",
  name: "Camo Cross I Can Do All Things Youth Faith Graphic Tee",
  brandToken: "b_crntsyfkzr",
  brandName: "J. Mack Designs",
  imageUrl:
    "https://cdn.faire.com/fastly/98876e8049c2600e961829f82c8e19fbbc57eaa12339a26785dcad15e06d0122.png",
  galleryImageUrls: [],
  priceDollars: 13.5,
  description:
    "This design comes printed on a unisex youth tee. These run true to size and are Rabbit Skins/LAT Brand.\n\nDetails:\n- Printed in Florida\n- Brand: Rabbit Skins/LAT\n- Color: Black\n- Fit: Unisex\n- Material: 100% cotton\n\nFaith * Christian * Positivity * Jesus * Religious * Christ * Kid * Youth * Boy * Camo * Biblical",
  tags: [],
  msrpDollars: 23,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:52:27.014Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
